import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { uiStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import { getSandMovementItems } from '../helpers/processProjects';
import CloseButton from '../components/close_button';

import '../../www/assets/css/sand_movement_detail.css';

const SandMovementDetail = () => {
	const { state } = useLocation();
	const { notFirstPage } = state ?? {};
	const sandMovementItem = getSandMovementItems();

	useEffect(() => {
		uiStore.setGlobalState({ isDetailPanelOpen: false });
	}, []);

	const handleClose = () => {
		const { getManager } = globalRefs;
		const routeManager = getManager('route');

		if (notFirstPage) {
			routeManager.goBack();
		} else {
			routeManager.goHomeRetainURLQueries();
		}
	};

	return (
		<div className='sand-movement-page'>
			<div className='sand-movement-page-content'>
				<CloseButton className='sand-movement-page-close' corner='left' responsive onClick={handleClose} />
				<h1 className='sand-movement-page-title'>{sandMovementItem.title}</h1>
				<img
					className='sand-movement-page-image'
					src={sandMovementItem.image}
					alt={sandMovementItem.title}
				/>
				<p className='sand-movement-page-description'>{sandMovementItem.description}</p>
			</div>
		</div>
	);
};

export default SandMovementDetail;
